// extracted by mini-css-extract-plugin
module.exports = {"l1tq0m1p":"l1tq0m1p","ik2yzzn":"ik2yzzn"};